import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientPreadmissionNotes = _resolveComponent("PatientPreadmissionNotes")!

  return (_ctx.referral)
    ? (_openBlock(), _createBlock(_component_PatientPreadmissionNotes, {
        key: 0,
        application: _ctx.application,
        "referral-id": _ctx.referralId,
        "is-referral": true,
        referral: _ctx.referral,
        closePreadmissionDialog: _ctx.closePreadmissionDialog,
        isPreadmissionDialog: true
      }, null, 8 /* PROPS */, ["application", "referral-id", "referral", "closePreadmissionDialog"]))
    : _createCommentVNode("v-if", true)
}